import { Box, IconButton, Tooltip } from "@mui/material";

import { EditOutlined } from "@mui/icons-material";

type UserMessageActionsProps = {
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
};

const UserMessageActions = ({
  isEditing,
  setIsEditing,
}: UserMessageActionsProps) => {
  const handleEditUserMessage = () => {
    setIsEditing(true);
  };

  return (
    <Box>
      {!isEditing && (
        <Tooltip title="Edit text" placement="bottom" enterDelay={0}>
          <IconButton
            onClick={handleEditUserMessage}
            data-attr="assistant:btn:edit-user-message"
          >
            <EditOutlined fontSize="small" sx={{ color: "#454746" }} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default UserMessageActions;
